var ProductFilter = /** @class */ (function () {
    function ProductFilter() {
        this.body = document.querySelector('body');
        this.pageOverlay = document.querySelector('[data-page-overlay]');
        this.pageLoader = document.querySelector('[data-page-loader]');
        this.productSortContainer = document.querySelector('[data-product-sort]');
        this.productCount = this.productSortContainer.querySelector('.products-page-sort-count span');
        this.sortSelect = this.productSortContainer.querySelector('.products-page-sort-select select');
        this.toggleFiltersButton = this.productSortContainer.querySelector('[data-product-toggle-filter]');
        this.filterContainer = document.querySelector('[data-product-filter]');
        this.filterWrapper = this.filterContainer.parentElement;
        this.clearFiltersButton = this.filterContainer.querySelector('.filter-clear-all');
        this.sortFilterContainer = this.filterContainer.querySelector('[data-product-filter="sort"]');
        this.sortRadioButtons = this.sortFilterContainer.querySelectorAll('input');
        this.filterGroups = this.filterContainer.querySelectorAll('[data-product-filter] .group-title');
        this.filterCheckboxes = this.filterContainer.querySelectorAll('input[type="checkbox"]');
        this.productsGridContainer = document.querySelector('[data-products-grid]');
        this.wordpressApiLink = "".concat(window.location.protocol, "//").concat(window.location.hostname, "/wp-admin/admin-ajax.php?action=products_filter");
        this.appliedFilters = {};
        this.initializeFiltersFromURL();
        this.addEventListeners();
    }
    ProductFilter.prototype.initializeFiltersFromURL = function () {
        var _this = this;
        // Set filter from page url if any are set
        var currentUrl = new URL(window.location.href);
        var params = new URLSearchParams(currentUrl.search);
        // Check if url has any params - set appliedFilters from url
        if (params.keys().next().done === false) {
            params.forEach(function (filterValue, filterType) {
                if (filterType === 'sort' && filterValue !== '') {
                    // if sort & not empty
                    _this.appliedFilters[filterType] = filterValue;
                }
                else if (filterValue !== '' && filterType !== 'sort') {
                    // if not sort & not empty
                    _this.appliedFilters[filterType] = JSON.parse(filterValue);
                }
                else {
                    // if no value - delete from url
                    var currentUrl_1 = new URL(window.location.href);
                    var params_1 = new URLSearchParams(currentUrl_1.search);
                    params_1.delete(filterType);
                    currentUrl_1.search = params_1.toString();
                    window.history.replaceState({}, '', currentUrl_1.toString());
                }
            });
            this.loadApiResults(); // Load results from api based on applied filters
            this.setFilterValues(); // Set active filter elements based on applied filters
        }
    };
    ProductFilter.prototype.setFilterValues = function () {
        var _this = this;
        // Set active elements on page load based on applied filters
        if (this.appliedFilters.hasOwnProperty('sort')) {
            // If has sort filter - set sort select
            this.sortSelect.value = this.appliedFilters['sort'];
            var filterType_1 = this.sortFilterContainer.getAttribute('data-product-filter');
            var filterValues = this.sortFilterContainer.querySelectorAll('input');
            filterValues.forEach(function (filterValue) {
                // Get filter value from data attribute
                var value = filterValue.value;
                // Check if such filter type exist and if it has the value
                if (_this.appliedFilters[filterType_1] && _this.appliedFilters[filterType_1].includes(value)) {
                    _this.sortFilterContainer.classList.add('active');
                    filterValue.setAttribute('checked', 'checked');
                }
            });
        }
        this.filterGroups.forEach(function (filterOption) {
            // Get filter type from data attribute
            var filterContainer = filterOption.parentElement;
            var filterType = filterContainer.getAttribute('data-product-filter');
            var filterValues = filterContainer.querySelectorAll('input');
            filterValues.forEach(function (filterValue) {
                // Get filter value from data attribute
                var value = parseInt(filterValue.value);
                // Check if such filter type exist and if it has the value
                if (_this.appliedFilters[filterType] && _this.appliedFilters[filterType].includes(value)) {
                    filterContainer.classList.add('active');
                    filterValue.setAttribute('checked', 'checked');
                }
            });
        });
    };
    ProductFilter.prototype.addEventListeners = function () {
        var _this = this;
        this.sortSelect.addEventListener('change', this.onSortChange.bind(this));
        this.toggleFiltersButton.addEventListener('click', this.onShowFilters.bind(this));
        this.clearFiltersButton.addEventListener('click', function () { return _this.onClearFilters(); });
        this.filterGroups.forEach(function (filterGroup) {
            filterGroup.addEventListener('click', _this.onToggleFilter.bind(_this));
            filterGroup.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ' || event.keyCode === 13 || event.keyCode === 32) {
                    _this.onToggleFilter(event);
                }
            });
        });
        this.sortRadioButtons.forEach(function (radioButton) {
            radioButton.addEventListener('change', _this.onFilterChange.bind(_this));
        });
        this.filterCheckboxes.forEach(function (checkbox) {
            checkbox.addEventListener('change', _this.onFilterChange.bind(_this));
            checkbox.addEventListener('keydown', _this.onCheckboxKeyDown.bind(_this));
        });
        window.addEventListener('resize', function () { return _this.destroyMobileFilter(); });
    };
    ProductFilter.prototype.onShowFilters = function () {
        if (this.filterWrapper.classList.contains('active')) {
            this.toggleFiltersButton.classList.remove('active');
            this.filterWrapper.classList.remove('active');
            this.body.classList.remove('no-scroll');
            this.pageOverlay.classList.remove('active');
        }
        else {
            this.body.classList.add('no-scroll');
            this.pageOverlay.classList.add('active');
            this.toggleFiltersButton.classList.add('active');
            this.filterWrapper.classList.add('active');
        }
    };
    ProductFilter.prototype.destroyMobileFilter = function () {
        var zIndex = getComputedStyle(document.body).zIndex;
        if (zIndex == "3") {
            this.toggleFiltersButton.classList.remove('active');
            this.filterWrapper.classList.remove('active');
            this.body.classList.remove('no-scroll');
            this.pageOverlay.classList.remove('active');
        }
    };
    ProductFilter.prototype.onToggleFilter = function (event) {
        var currentTarget = event.currentTarget;
        var filterContainer = currentTarget.parentElement;
        if (filterContainer.classList.contains('active')) {
            filterContainer.classList.remove('active');
        }
        else {
            filterContainer.classList.add('active');
        }
    };
    ProductFilter.prototype.onSortChange = function (event) {
        var _this = this;
        var sortingOption = event.target.value;
        this.setFilter('sort', sortingOption);
        var filterValues = this.sortFilterContainer.querySelectorAll('input');
        filterValues.forEach(function (filterValue) {
            // Get filter value from data attribute
            var value = filterValue.value;
            // Check if such filter type exist and if it has the value
            if (sortingOption === value) {
                _this.sortFilterContainer.classList.add('active');
                filterValue.checked = true;
            }
        });
    };
    ProductFilter.prototype.onClearFilters = function () {
        // If filter is set - don't clear it, else clear the object fully
        this.appliedFilters = "sort" in this.appliedFilters ? { sort: this.appliedFilters.sort } : {};
        this.filterGroups.forEach(function (filterOption) {
            // Get filter type from data attribute
            var filterContainer = filterOption.parentElement;
            var filterValues = filterContainer.querySelectorAll('input');
            filterContainer.classList.remove('active');
            filterValues.forEach(function (filterValue) {
                filterValue.parentElement.classList.remove('disabled');
                filterValue.checked = false;
            });
        });
        this.updatePageUrl('clear', 'clear');
        this.loadApiResults();
    };
    ProductFilter.prototype.onCheckboxKeyDown = function (event) {
        var currentCheckbox = event.target;
        var checkboxes = Array.from(this.filterCheckboxes);
        var currentIndex = checkboxes.indexOf(currentCheckbox);
        if (event.key === 'ArrowDown' && currentIndex < checkboxes.length - 1) {
            event.preventDefault(); // Prevent the default action (if any)
            var nextCheckbox = checkboxes[currentIndex + 1];
            nextCheckbox.focus();
        }
        else if (event.key === 'ArrowUp' && currentIndex > 0) {
            event.preventDefault(); // Prevent the default action (if any)
            var prevCheckbox = checkboxes[currentIndex - 1];
            prevCheckbox.focus();
        }
        // on enter key filterChange
        if (event.key === 'Enter' || event.key === ' ' || event.keyCode === 13 || event.keyCode === 32) {
            this.onFilterChange(event);
        }
    };
    ProductFilter.prototype.onFilterChange = function (event) {
        var currentInput = event.currentTarget;
        var currentTarget = event.currentTarget;
        var filterGroupContainer = currentTarget.parentElement.parentElement.parentElement;
        var filterType = filterGroupContainer.dataset.productFilter;
        var filterValue = currentInput.value;
        if (!currentInput.checked) {
            currentInput.setAttribute('checked', 'checked');
        }
        else {
            currentInput.removeAttribute('checked');
        }
        this.setFilter(filterType, filterValue);
        this.updateCheckboxVisibility(currentTarget, filterType, filterValue);
    };
    ProductFilter.prototype.updateCheckboxVisibility = function (currentTarget, filterType, filterValue) {
        var _this = this;
        // Check if the clicked category is a child category
        var filterContainer = currentTarget.parentElement;
        var isChildCategory = filterContainer.hasAttribute('data-filter-parent');
        if (isChildCategory) {
            var checkboxes = this.filterContainer.querySelectorAll("[data-filter-parent]");
            checkboxes.forEach(function (childCategory) {
                // Update visibility and state of child categories based on the main category selection
                var hasIndustryFilter = _this.appliedFilters.hasOwnProperty('industry');
                var checkboxValue = childCategory.querySelector('input').value;
                if (hasIndustryFilter) {
                    var parentId = childCategory.getAttribute('data-filter-parent');
                    var hasParent = _this.appliedFilters['industry'].includes(parseInt(parentId));
                    var hasCurrent = _this.appliedFilters['industry'].includes(parseInt(checkboxValue));
                    if (hasCurrent && !hasParent) {
                        childCategory.classList.remove('disabled');
                        childCategory.querySelector('input').checked = true;
                    }
                    else if (!hasCurrent && hasParent) {
                        childCategory.classList.remove('disabled');
                        childCategory.querySelector('input').checked = false;
                    }
                }
                else {
                    childCategory.classList.remove('disabled');
                }
            });
        }
        else {
            var checkboxes = this.filterContainer.querySelectorAll("[data-filter-parent]");
            checkboxes.forEach(function (childCategory) {
                var hasIndustryFilter = _this.appliedFilters.hasOwnProperty('industry');
                var checkboxValue = childCategory.querySelector('input').value;
                if (hasIndustryFilter) {
                    // Update visibility and state of child categories based on the main category selection
                    var parentId = childCategory.getAttribute('data-filter-parent');
                    var isMultiple = _this.appliedFilters['industry'].length > 1;
                    var hasParent = _this.appliedFilters['industry'].includes(parseInt(parentId));
                    var hasCurrent = _this.appliedFilters['industry'].includes(parseInt(checkboxValue));
                    if (isMultiple) {
                        if (!hasParent && !hasCurrent) {
                            childCategory.classList.add('disabled');
                            childCategory.querySelector('input').checked = false;
                        }
                        else if (hasParent && !hasCurrent) {
                            childCategory.classList.remove('disabled');
                            childCategory.querySelector('input').checked = false;
                        }
                        else if (!hasParent && hasCurrent) {
                            childCategory.classList.add('disabled');
                            childCategory.querySelector('input').checked = false;
                            _this.setFilter('industry', checkboxValue);
                        }
                    }
                    else {
                        if (!hasParent && hasCurrent) {
                            childCategory.classList.remove('disabled');
                            childCategory.querySelector('input').checked = false;
                            _this.setFilter('industry', checkboxValue);
                        }
                        else if (hasParent && !hasCurrent) {
                            childCategory.classList.remove('disabled');
                            childCategory.querySelector('input').checked = false;
                        }
                        else if (!hasParent && !hasCurrent) {
                            childCategory.classList.add('disabled');
                            childCategory.querySelector('input').checked = false;
                        }
                    }
                }
            });
            checkboxes.forEach(function (childCategory) {
                var hasIndustryFilter = _this.appliedFilters.hasOwnProperty('industry');
                if (!hasIndustryFilter) {
                    childCategory.classList.remove('disabled');
                    childCategory.querySelector('input').checked = false;
                }
            });
        }
    };
    ProductFilter.prototype.setFilter = function (filterType, filterValue) {
        // Set filter values and type based on clicked value
        if (filterType === 'sort') {
            // If filter type is sort - update filter value
            this.appliedFilters[filterType] = filterValue;
        }
        else if (this.appliedFilters.hasOwnProperty(filterType)) {
            // Check if appliedFilter already exist such filter type
            var filterArray = this.appliedFilters[filterType];
            var index = filterArray.indexOf(parseInt(filterValue.toString()));
            if (index === -1) {
                // If filter value doesn't exist, add it to the filterArray
                filterArray.push(parseInt(filterValue.toString()));
            }
            else {
                // If filterValue already exists, remove it from the filterArray
                filterArray.splice(index, 1);
                // If the filterArray is empty after removal, delete the filterType
                if (filterArray.length === 0) {
                    delete this.appliedFilters[filterType];
                }
            }
        }
        else if (!this.appliedFilters.hasOwnProperty(filterType)) {
            // If filterType doesn't exist, create a new entry with an array containing filterValue
            this.appliedFilters[filterType] = [parseInt(filterValue.toString())];
        }
        this.updatePageUrl(filterType, filterValue);
        this.loadApiResults();
    };
    ProductFilter.prototype.updatePageUrl = function (filterType, filterValue) {
        // Update the URL with the new query parameters
        var currentUrl = new URL(window.location.href);
        var params = new URLSearchParams(currentUrl.search);
        filterType.replace('-', '_');
        if (filterValue === 'clear') {
            // If filterValue is "clear," remove all filters except sort if it's set
            var paramsToDelete_1 = [];
            params.forEach(function (value, key) {
                if (key !== "sort") {
                    paramsToDelete_1.push(key);
                }
            });
            paramsToDelete_1.forEach(function (key) {
                params.delete(key);
            });
        }
        else if (filterType === 'sort') {
            // If filter type is sort - update filter value
            params.set(filterType, filterValue.toString());
        }
        else if (this.appliedFilters.hasOwnProperty(filterType)) {
            // if filter exists
            params.set(filterType, JSON.stringify(this.appliedFilters[filterType]));
        }
        else if (!this.appliedFilters.hasOwnProperty(filterType)) {
            // if not - remove param
            params.delete(filterType);
        }
        currentUrl.search = params.toString();
        window.history.replaceState({}, '', currentUrl.toString());
    };
    ProductFilter.prototype.loadApiResults = function () {
        var _this = this;
        // Load results from api based on applied filters
        this.body.classList.add('no-scroll');
        this.pageOverlay.classList.add('active');
        this.pageLoader.classList.add('active');
        var options = {
            method: 'POST',
            body: JSON.stringify(this.appliedFilters)
        };
        fetch(this.wordpressApiLink, options)
            .then(function (response) { return response.json(); })
            .then(function (response) {
            if (response.length > 0) {
                // Check if there 'are any results - set data & manipulate DOM
                _this.loadedProducts = response;
                _this.setDomElements();
            }
        })
            .catch(function (error) {
            console.error('Fetch error:', error);
        })
            .finally(function () {
            if (_this.filterWrapper.classList.contains('active')) {
                _this.pageLoader.classList.remove('active');
            }
            else {
                _this.body.classList.remove('no-scroll');
                _this.pageOverlay.classList.remove('active');
                _this.pageLoader.classList.remove('active');
            }
        });
    };
    ProductFilter.prototype.setDomElements = function () {
        var _this = this;
        this.productsGridContainer.innerHTML = '';
        this.productCount.innerHTML = this.loadedProducts.length.toString();
        this.loadedProducts.map(function (product) {
            _this.productsGridContainer.innerHTML += product;
        });
        // Refresh AOS after new products are loaded
        window.aos.refresh();
    };
    return ProductFilter;
}());
export default ProductFilter;
